export type PrefixData = {
    prefix: string
    flag: string
    name: string
    code?: string
    id?: number
}

export const countryPhones: Array<PrefixData> = [
    { id: 2, name: 'Afghanistan', flag: 'afghanistan', prefix: '+93' },
    { id: 248, name: 'Åland Islands', flag: 'Åland-islands', prefix: '+358' },
    { id: 5, name: 'Albania', flag: 'albania', prefix: '+355' },
    { id: 62, name: 'Algeria', flag: 'algeria', prefix: '+213' },
    { id: 11, name: 'American Samoa', flag: 'american-samoa', prefix: '+1684' },
    { id: 6, name: 'Andorra', flag: 'andorra', prefix: '+376' },
    { id: 3, name: 'Angola', flag: 'angola', prefix: '+244' },
    { id: 4, name: 'Anguilla', flag: 'anguilla', prefix: '+1264' },
    { id: 12, name: 'Antarctica', flag: 'antarctica', prefix: '+672' },
    { id: 14, name: 'Antigua and Barbuda', flag: 'antigua-and-barbuda', prefix: '+1268' },
    { id: 9, name: 'Argentina', flag: 'argentina', prefix: '+54' },
    { id: 10, name: 'Armenia', flag: 'armenia', prefix: '+374' },
    { id: 1, name: 'Aruba', flag: 'aruba', prefix: '+297' },
    { id: 15, name: 'Australia', flag: 'australia', prefix: '+61' },
    { id: 16, name: 'Austria', flag: 'austria', prefix: '+43' },
    { id: 17, name: 'Azerbaijan', flag: 'azerbaijan', prefix: '+994' },
    { id: 25, name: 'Bahamas', flag: 'bahamas', prefix: '+1242' },
    { id: 24, name: 'Bahrain', flag: 'bahrain', prefix: '+973' },
    { id: 22, name: 'Bangladesh', flag: 'bangladesh', prefix: '+880' },
    { id: 32, name: 'Barbados', flag: 'barbados', prefix: '+1246' },
    { id: 27, name: 'Belarus', flag: 'belarus', prefix: '+375' },
    { id: 19, name: 'Belgium', flag: 'belgium', prefix: '+32' },
    { id: 28, name: 'Belize', flag: 'belize', prefix: '+501' },
    { id: 20, name: 'Benin', flag: 'benin', prefix: '+229' },
    { id: 29, name: 'Bermuda', flag: 'bermuda', prefix: '+1441' },
    { id: 34, name: 'Bhutan', flag: 'bhutan', prefix: '+975' },
    { id: 30, name: 'Bolivia', flag: 'bolivia', prefix: '+591' },
    { id: 26, name: 'Bosnia and Herzegovina', flag: 'bosnia-and-herzegovina', prefix: '+387' },
    { id: 36, name: 'Botswana', flag: 'botswana', prefix: '+267' },
    { id: 35, name: 'Bouvet Island', flag: 'bouvet-island', prefix: '+47' },
    { id: 31, name: 'Brazil', flag: 'brazil', prefix: '+55' },
    {
        id: 101,
        name: 'British Indian Ocean Territory',
        flag: 'british-indian-ocean-territory',
        prefix: '+246',
    },
    { id: 33, name: 'Brunei', flag: 'brunei', prefix: '+673' },
    { id: 23, name: 'Bulgaria', flag: 'bulgaria', prefix: '+359' },
    { id: 21, name: 'Burkina Faso', flag: 'burkina-faso', prefix: '+226' },
    { id: 18, name: 'Burundi', flag: 'burundi', prefix: '+257' },
    { id: 114, name: 'Cambodia', flag: 'cambodia', prefix: '+855' },
    { id: 44, name: 'Cameroon', flag: 'cameroon', prefix: '+237' },

    { id: 50, name: 'Cape Verde', flag: 'cape-verde', prefix: '+238' },
    { id: 54, name: 'Cayman Islands', flag: 'cayman-islands', prefix: '+1345' },
    { id: 37, name: 'Central African Republic', flag: 'central-african-republic', prefix: '+236' },
    { id: 206, name: 'Chad', flag: 'chad', prefix: '+235' },
    { id: 41, name: 'Chile', flag: 'chile', prefix: '+56' },
    { id: 42, name: 'China', flag: 'china', prefix: '+86' },
    { id: 53, name: 'Christmas Island', flag: 'christmas-island', prefix: '+61' },
    { id: 39, name: 'Cocos (Keeling) Islands', flag: 'cocos-(keeling)-islands', prefix: '+61' },
    { id: 48, name: 'Colombia', flag: 'colombia', prefix: '+57' },
    { id: 49, name: 'Comoros', flag: 'comoros', prefix: '+269' },
    { id: 46, name: 'Congo', flag: 'congo', prefix: '+242' },
    {
        id: 45,
        name: 'Congo, The Democratic Republic of the',
        flag: 'congo,-the-democratic-republic-of-the',
        prefix: '+243',
    },
    { id: 47, name: 'Cook Islands', flag: 'cook-islands', prefix: '+682' },
    { id: 51, name: 'Costa Rica', flag: 'costa-rica', prefix: '+506' },
    { id: 43, name: "Côte d'Ivoire", flag: "côte-d'ivoire", prefix: '+225' },
    { id: 96, name: 'Croatia', flag: 'croatia', prefix: '+385' },
    { id: 52, name: 'Cuba', flag: 'cuba', prefix: '+53' },
    { id: 55, name: 'Cyprus', flag: 'cyprus', prefix: '+357' },
    { id: 56, name: 'Czech Republic', flag: 'czech-republic', prefix: '+420' },
    { id: 60, name: 'Denmark', flag: 'denmark', prefix: '+45' },
    { id: 58, name: 'Djibouti', flag: 'djibouti', prefix: '+253' },
    { id: 59, name: 'Dominica', flag: 'dominica', prefix: '+1767' },
    { id: 61, name: 'Dominican Republic', flag: 'dominican-republic', prefix: '+1809' },
    { id: 212, name: 'East Timor', flag: 'east-timor', prefix: '+670' },
    { id: 63, name: 'Ecuador', flag: 'ecuador', prefix: '+593' },
    { id: 64, name: 'Egypt', flag: 'egypt', prefix: '+20' },
    { id: 193, name: 'El Salvador', flag: 'el-salvador', prefix: '+503' },
    { id: 240, name: 'England', flag: 'england', prefix: '+44' },
    { id: 85, name: 'Equatorial Guinea', flag: 'equatorial-guinea', prefix: '+240' },
    { id: 65, name: 'Eritrea', flag: 'eritrea', prefix: '+291' },
    { id: 68, name: 'Estonia', flag: 'estonia', prefix: '+372' },
    { id: 69, name: 'Ethiopia', flag: 'ethiopia', prefix: '+251' },
    { id: 72, name: 'Falkland Islands', flag: 'falkland-islands', prefix: '+500' },
    { id: 74, name: 'Faroe Islands', flag: 'faroe-islands', prefix: '+298' },
    { id: 71, name: 'Fiji Islands', flag: 'fiji-islands', prefix: '+679' },
    { id: 70, name: 'Finland', flag: 'finland', prefix: '+358' },
    { id: 73, name: 'France', flag: 'france', prefix: '+33' },
    { id: 90, name: 'French Guiana', flag: 'french-guiana', prefix: '+594' },
    { id: 178, name: 'French Polynesia', flag: 'french-polynesia', prefix: '+689' },
    {
        id: 13,
        name: 'French Southern territories',
        flag: 'french-southern-territories',
        prefix: '+262',
    },
    { id: 76, name: 'Gabon', flag: 'gabon', prefix: '+241' },
    { id: 83, name: 'Gambia', flag: 'gambia', prefix: '+220' },
    { id: 78, name: 'Georgia', flag: 'georgia', prefix: '+995' },
    { id: 57, name: 'Germany', flag: 'germany', prefix: '+49' },
    { id: 79, name: 'Ghana', flag: 'ghana', prefix: '+233' },
    { id: 80, name: 'Gibraltar', flag: 'gibraltar', prefix: '+350' },
    { id: 86, name: 'Greece', flag: 'greece', prefix: '+30' },
    { id: 88, name: 'Greenland', flag: 'greenland', prefix: '+299' },
    { id: 87, name: 'Grenada', flag: 'grenada', prefix: '+1473' },
    { id: 82, name: 'Guadeloupe', flag: 'guadeloupe', prefix: '+590' },
    { id: 91, name: 'Guam', flag: 'guam', prefix: '+1671' },
    { id: 89, name: 'Guatemala', flag: 'guatemala', prefix: '+502' },
    { id: 81, name: 'Guinea', flag: 'guinea', prefix: '+224' },
    { id: 84, name: 'Guinea-Bissau', flag: 'guinea-bissau', prefix: '+245' },
    { id: 92, name: 'Guyana', flag: 'guyana', prefix: '+592' },
    { id: 97, name: 'Haiti', flag: 'haiti', prefix: '+509' },
    {
        id: 226,
        name: 'Holy See (Vatican City State)',
        flag: 'holy-see-(vatican-city-state)',
        prefix: '+379',
    },
    { id: 95, name: 'Honduras', flag: 'honduras', prefix: '+504' },
    { id: 93, name: 'Hong Kong', flag: 'hong-kong', prefix: '+852' },
    { id: 98, name: 'Hungary', flag: 'hungary', prefix: '+36' },
    { id: 105, name: 'Iceland', flag: 'iceland', prefix: '+354' },
    { id: 100, name: 'India', flag: 'india', prefix: '+91' },
    { id: 99, name: 'Indonesia', flag: 'indonesia', prefix: '+62' },
    { id: 104, name: 'Iraq', flag: 'iraq', prefix: '+964' },
    { id: 102, name: 'Ireland', flag: 'ireland', prefix: '+353' },
    { id: 106, name: 'Israel', flag: 'israel', prefix: '+972' },
    { id: 107, name: 'Italy', flag: 'italy', prefix: '+39' },
    { id: 108, name: 'Jamaica', flag: 'jamaica', prefix: '+1876' },
    { id: 110, name: 'Japan', flag: 'japan', prefix: '+81' },
    { id: 109, name: 'Jordan', flag: 'jordan', prefix: '+962' },
    { id: 111, name: 'Kazakhstan', flag: 'kazakhstan', prefix: '+7' },
    { id: 112, name: 'Kenya', flag: 'kenya', prefix: '+254' },
    { id: 115, name: 'Kiribati', flag: 'kiribati', prefix: '+686' },
    { id: 243, name: 'Kosovo', flag: 'kosovo', prefix: '+383' },
    { id: 118, name: 'Kuwait', flag: 'kuwait', prefix: '+965' },
    { id: 113, name: 'Kyrgyzstan', flag: 'kyrgyzstan', prefix: '+996' },
    { id: 119, name: 'Laos', flag: 'laos', prefix: '+856' },
    { id: 129, name: 'Latvia', flag: 'latvia', prefix: '+371' },
    { id: 120, name: 'Lebanon', flag: 'lebanon', prefix: '+961' },
    { id: 126, name: 'Lesotho', flag: 'lesotho', prefix: '+266' },
    { id: 121, name: 'Liberia', flag: 'liberia', prefix: '+231' },
    { id: 122, name: 'Libyan Arab Jamahiriya', flag: 'libyan-arab-jamahiriya', prefix: '+218' },
    { id: 124, name: 'Liechtenstein', flag: 'liechtenstein', prefix: '+423' },
    { id: 127, name: 'Lithuania', flag: 'lithuania', prefix: '+370' },
    { id: 128, name: 'Luxembourg', flag: 'luxembourg', prefix: '+352' },
    { id: 130, name: 'Macao', flag: 'macao', prefix: '+853' },
    { id: 138, name: 'Macedonia', flag: 'macedonia', prefix: '+389' },
    { id: 134, name: 'Madagascar', flag: 'madagascar', prefix: '+261' },
    { id: 149, name: 'Malawi', flag: 'malawi', prefix: '+265' },
    { id: 150, name: 'Malaysia', flag: 'malaysia', prefix: '+60' },
    { id: 135, name: 'Maldives', flag: 'maldives', prefix: '+960' },
    { id: 139, name: 'Mali', flag: 'mali', prefix: '+223' },
    { id: 140, name: 'Malta', flag: 'malta', prefix: '+356' },
    { id: 137, name: 'Marshall Islands', flag: 'marshall-islands', prefix: '+692' },
    { id: 147, name: 'Martinique', flag: 'martinique', prefix: '+596' },
    { id: 145, name: 'Mauritania', flag: 'mauritania', prefix: '+222' },
    { id: 148, name: 'Mauritius', flag: 'mauritius', prefix: '+230' },
    { id: 151, name: 'Mayotte', flag: 'mayotte', prefix: '+262' },
    { id: 136, name: 'Mexico', flag: 'mexico', prefix: '+52' },
    {
        id: 75,
        name: 'Micronesia, Federated States of',
        flag: 'micronesia,-federated-states-of',
        prefix: '+691',
    },
    { id: 133, name: 'Moldova', flag: 'moldova', prefix: '+373' },
    { id: 132, name: 'Monaco', flag: 'monaco', prefix: '+377' },
    { id: 142, name: 'Mongolia', flag: 'mongolia', prefix: '+976' },
    { id: 247, name: 'Montenegro', flag: 'montenegro', prefix: '+382' },
    { id: 146, name: 'Montserrat', flag: 'montserrat', prefix: '+1664' },
    { id: 131, name: 'Morocco', flag: 'morocco', prefix: '+212' },
    { id: 144, name: 'Mozambique', flag: 'mozambique', prefix: '+258' },
    { id: 141, name: 'Myanmar', flag: 'myanmar', prefix: '+95' },
    { id: 152, name: 'Namibia', flag: 'namibia', prefix: '+264' },
    { id: 162, name: 'Nauru', flag: 'nauru', prefix: '+674' },
    { id: 161, name: 'Nepal', flag: 'nepal', prefix: '+977' },
    { id: 159, name: 'Netherlands', flag: 'netherlands', prefix: '+31' },
    { id: 7, name: 'Netherlands Antilles', flag: 'netherlands-antilles', prefix: '+599' },
    { id: 153, name: 'New Caledonia', flag: 'new-caledonia', prefix: '+687' },
    { id: 163, name: 'New Zealand', flag: 'new-zealand', prefix: '+64' },
    { id: 157, name: 'Nicaragua', flag: 'nicaragua', prefix: '+505' },
    { id: 154, name: 'Niger', flag: 'niger', prefix: '+227' },
    { id: 156, name: 'Nigeria', flag: 'nigeria', prefix: '+234' },
    { id: 158, name: 'Niue', flag: 'niue', prefix: '+683' },
    { id: 155, name: 'Norfolk Island', flag: 'norfolk-island', prefix: '+672' },
    { id: 174, name: 'North Korea', flag: 'north-korea', prefix: '+850' },
    {
        id: 143,
        name: 'Northern Mariana Islands',
        flag: 'northern-mariana-islands',
        prefix: '+1670',
    },
    { id: 160, name: 'Norway', flag: 'norway', prefix: '+47' },
    { id: 164, name: 'Oman', flag: 'oman', prefix: '+968' },
    { id: 165, name: 'Pakistan', flag: 'pakistan', prefix: '+92' },
    { id: 170, name: 'Palau', flag: 'palau', prefix: '+680' },
    { id: 177, name: 'Palestine', flag: 'palestine', prefix: '+970' },
    { id: 166, name: 'Panama', flag: 'panama', prefix: '+507' },
    { id: 171, name: 'Papua New Guinea', flag: 'papua-new-guinea', prefix: '+675' },
    { id: 176, name: 'Paraguay', flag: 'paraguay', prefix: '+595' },
    { id: 168, name: 'Peru', flag: 'peru', prefix: '+51' },
    { id: 169, name: 'Philippines', flag: 'philippines', prefix: '+63' },
    { id: 167, name: 'Pitcairn', flag: 'pitcairn', prefix: '+64' },
    { id: 172, name: 'Poland', flag: 'poland', prefix: '+48' },
    { id: 175, name: 'Portugal', flag: 'portugal', prefix: '+351' },
    { id: 173, name: 'Puerto Rico', flag: 'puerto-rico', prefix: '+1787' },
    { id: 179, name: 'Qatar', flag: 'qatar', prefix: '+974' },
    { id: 180, name: 'Réunion', flag: 'réunion', prefix: '+262' },
    { id: 181, name: 'Romania', flag: 'romania', prefix: '+40' },
    { id: 183, name: 'Rwanda', flag: 'rwanda', prefix: '+250' },
    { id: 189, name: 'Saint Helena', flag: 'saint-helena', prefix: '+290' },
    { id: 116, name: 'Saint Kitts and Nevis', flag: 'saint-kitts-and-nevis', prefix: '+1869' },
    { id: 123, name: 'Saint Lucia', flag: 'saint-lucia', prefix: '+1758' },
    {
        id: 196,
        name: 'Saint Pierre and Miquelon',
        flag: 'saint-pierre-and-miquelon',
        prefix: '+508',
    },
    {
        id: 227,
        name: 'Saint Vincent and the Grenadines',
        flag: 'saint-vincent-and-the-grenadines',
        prefix: '+1784',
    },
    { id: 234, name: 'Samoa', flag: 'samoa', prefix: '+685' },
    { id: 194, name: 'San Marino', flag: 'san-marino', prefix: '+378' },
    { id: 197, name: 'Sao Tome and Principe', flag: 'sao-tome-and-principe', prefix: '+239' },
    { id: 184, name: 'Saudi Arabia', flag: 'saudi-arabia', prefix: '+966' },
    { id: 241, name: 'Scotland', flag: 'scotland', prefix: '+44' },
    { id: 186, name: 'Senegal', flag: 'senegal', prefix: '+221' },
    { id: 246, name: 'Serbia', flag: 'serbia', prefix: '+381' },
    { id: 203, name: 'Seychelles', flag: 'seychelles', prefix: '+248' },
    { id: 192, name: 'Sierra Leone', flag: 'sierra-leone', prefix: '+232' },
    { id: 187, name: 'Singapore', flag: 'singapore', prefix: '+65' },
    { id: 199, name: 'Slovakia', flag: 'slovakia', prefix: '+421' },
    { id: 200, name: 'Slovenia', flag: 'slovenia', prefix: '+386' },
    { id: 191, name: 'Solomon Islands', flag: 'solomon-islands', prefix: '+677' },
    { id: 195, name: 'Somalia', flag: 'somalia', prefix: '+252' },
    { id: 237, name: 'South Africa', flag: 'south-africa', prefix: '+27' },
    {
        id: 188,
        name: 'South Georgia and the South Sandwich Islands',
        flag: 'south-georgia-and-the-south-sandwich-islands',
        prefix: '+500',
    },
    { id: 117, name: 'South Korea', flag: 'south-korea', prefix: '+82' },
    { id: 67, name: 'Spain', flag: 'spain', prefix: '+34' },
    { id: 125, name: 'Sri Lanka', flag: 'sri-lanka', prefix: '+94' },
    { id: 185, name: 'Sudan', flag: 'sudan', prefix: '+249' },
    { id: 198, name: 'Suriname:', flag: 'suriname:', prefix: '+597' },
    { id: 190, name: 'Svalbard and Jan Mayen', flag: 'svalbard-and-jan-mayen', prefix: '+47' },
    { id: 202, name: 'Swaziland', flag: 'swaziland', prefix: '+268' },
    { id: 201, name: 'Sweden', flag: 'sweden', prefix: '+46' },
    { id: 40, name: 'Switzerland', flag: 'switzerland', prefix: '+41' },
    { id: 204, name: 'Syria', flag: 'syria', prefix: '+963' },
    { id: 218, name: 'Taiwan', flag: 'taiwan', prefix: '+886' },
    { id: 209, name: 'Tajikistan', flag: 'tajikistan', prefix: '+992' },
    { id: 219, name: 'Tanzania', flag: 'tanzania', prefix: '+255' },
    { id: 208, name: 'Thailand', flag: 'thailand', prefix: '+66' },
    { id: 207, name: 'Togo', flag: 'togo', prefix: '+228' },
    { id: 210, name: 'Tokelau', flag: 'tokelau', prefix: '+690' },
    { id: 213, name: 'Tonga', flag: 'tonga', prefix: '+676' },
    { id: 214, name: 'Trinid:ad and Tobago', flag: 'trinid:ad-and-tobago', prefix: '+1868' },
    { id: 215, name: 'Tunisia', flag: 'tunisia', prefix: '+216' },
    { id: 216, name: 'Turkey', flag: 'turkey', prefix: '+90' },
    { id: 211, name: 'Turkmenistan', flag: 'turkmenistan', prefix: '+993' },
    {
        id: 205,
        name: 'Turks and Caicos Islands',
        flag: 'turks-and-caicos-islands',
        prefix: '+1649',
    },
    { id: 217, name: 'Tuvalu', flag: 'tuvalu', prefix: '+688' },
    { id: 220, name: 'Uganda', flag: 'uganda', prefix: '+256' },
    { id: 221, name: 'Ukraine', flag: 'ukraine', prefix: '+380' },
    { id: 8, name: 'United Arab Emirates', flag: 'united-arab-emirates', prefix: '+971' },
    { id: 77, name: 'United Kingdom', flag: 'united-kingdom', prefix: '+44' },
    { id: 224, name: 'United States', flag: 'united-states', prefix: '+1' },
    { id: 38, name: 'Canada', flag: 'canada', prefix: '+1' },
    {
        id: 222,
        name: 'United States Minor Outlying Islands',
        flag: 'united-states-minor-outlying-islands',
        prefix: '+1',
    },
    { id: 223, name: 'Uruguay', flag: 'uruguay', prefix: '+598' },
    { id: 225, name: 'Uzbekistan', flag: 'uzbekistan', prefix: '+998' },
    { id: 232, name: 'Vanuatu', flag: 'vanuatu', prefix: '+678' },
    { id: 228, name: 'Venezuela', flag: 'venezuela', prefix: '+58' },
    { id: 231, name: 'Vietnam', flag: 'vietnam', prefix: '+84' },
    { id: 229, name: 'Virgin Islands, British', flag: 'virgin-islands,-british', prefix: '+1284' },
    { id: 230, name: 'Virgin Islands, U.S.', flag: 'virgin-islands,-u.s.', prefix: '+1340' },
    { id: 242, name: 'Wales', flag: 'wales', prefix: '+44' },
    { id: 233, name: 'Wallis and Futuna', flag: 'wallis-and-futuna', prefix: '+681' },
    { id: 66, name: 'Western Sahara', flag: 'western-sahara', prefix: '+212' },
    { id: 235, name: 'Yemen', flag: 'yemen', prefix: '+967' },
    { id: 238, name: 'Zambia', flag: 'zambia', prefix: '+260' },
    { id: 239, name: 'Zimbabwe', flag: 'zimbabwe', prefix: '+263' },
]
